import { pendingWorkOrderCheckSchema, type PendingWorkOrderCheck } from "../../../shared/manual-packaging/pending-work-order-check";
import type { PackagingPlanRow } from "./week39-types";

export type PendingOrderCheckState = { loading: boolean; error: string; data: PendingWorkOrderCheck | null };
export function packagingWorkOrderInput(value: string) {
  const compact = value.replace(/\s+/gu, "");
  return /^\d{9}$/u.test(compact) ? `${compact.slice(0, 6)} ${compact.slice(6)}` : value.trim();
}
export function pendingOrderCheckKey(row: Pick<PackagingPlanRow, "sourceRow" | "productCode" | "country">) {
  return JSON.stringify([row.sourceRow, row.productCode, row.country]);
}

export function validatePendingOrderCheck(value: unknown, row: Pick<PackagingPlanRow, "sourceRow" | "productCode" | "country">) {
  const parsed = pendingWorkOrderCheckSchema.safeParse(value);
  if (!parsed.success) throw new Error("Mikro kontrol yanıtı doğrulanamadı. Yeniden kontrol et.");
  const data = parsed.data;
  if (data.sourceRow !== row.sourceRow || data.productCode !== row.productCode || data.country !== row.country || data.truncated) {
    throw new Error("Mikro kontrolü eksik veya farklı bir işe ait. Yeniden kontrol et.");
  }
  return data;
}
